module.exports = __webpack_public_path__ + "media/svg/account-tie-583aeda1.svg";